import React, { useState, useEffect, useContext, useRef } from "react";
import { Select, Spin, Button, Input } from "antd";
import apiClientconops from "../../../ApiEndpoint/apiClientconops";
import apiUrlconops from "../../../ApiEndpoint/configconops";
import { BehaviorSubject, from, lastValueFrom } from 'rxjs';
import { useNavigate } from 'react-router-dom';
import { debounceTime, distinctUntilChanged, switchMap } from 'rxjs/operators';
import qs from 'qs';
import { ConopsContext } from "../../conops-hooks/ConopsContext";
import { SearchOutlined, EnterOutlined } from '@ant-design/icons';
import "./conopsfilterbar.css"
import ConopsRefineSearch from "../../conops-components/conops-refinesearch/conopsrefinesearch"

const { Option } = Select;

const ConopsFilterBar = () => {
    const navigate = useNavigate();
    const [states, setStates] = useState([]);
    const [loading, setLoading] = useState(false);
    const [cities, setCities] = useState([]);
    const [counties, setCounties] = useState([]);
    const [debounceDuration] = useState(1000);
    const [selectedFacilityValue, setSelectedFacilityValue] = useState(null);


    //Loading filter data


    const searchStateSubject = useRef(new BehaviorSubject(''));
    const searchCountySubject = useRef(new BehaviorSubject(''));
    const searchCitySubject = useRef(new BehaviorSubject(''));
    const searchFacilitySubject = useRef(new BehaviorSubject(''));



    //Focusing filter data
    const [stateFocused, setStateFocused] = useState(false);
    const [countyFocused, setCountyFocused] = useState(false);
    const [cityFocused, setCityFocused] = useState(false);
    const [facilityFocused, setFacilityFocused] = useState(false);


    //loadig filter data
    const [facilities, setFacilities] = useState([]);
    //open search
    const { selectedOpenSearchValue, setSelectedOpenSearchValue, selectedState, setSelectedState, selectedCounty, setSelectedCounty, setFacilityTableObject,
        selectedCity, setSelectedCity, selectedFacility, setSelectedFacility, setRegisterId, setCountyObject, selectedFacilityType, refineSearchProjectObject } = useContext(ConopsContext);


    //Refine Search Modal 
    const [refineSearchModalOpen, setRefineSearchModalOpen] = useState(false);


    // 🔍 New API call for open search summary (triggered only on Enter)
    useEffect(() => {
        // Run only when open search has a value AND the state dropdown is focused
        if (!selectedOpenSearchValue) return;
        const fetchSearchSummary = async () => {
            try {
                setLoading(true);

                const response = await apiClientconops.get(
                    `${apiUrlconops}/search_facility_location_summary`,
                    {
                        params: {
                            q: selectedOpenSearchValue,
                            ...(selectedState && { fac_state: selectedState }),
                            ...(selectedCounty && { fac_county: selectedCounty }),
                            ...(selectedCity && { fac_city: selectedCity }),
                            ...(selectedFacility && { registry_id: selectedFacility }),
                            ...(selectedFacilityType && { fac_type: selectedFacilityType }),
                        },
                        paramsSerializer: params => qs.stringify(params, { arrayFormat: "repeat" }),
                    }
                );

                const data = response.data || {};

                // Update dropdowns if data exists
                setStates(data.states || []);
                setCounties(data.counties || []);
                setCities(data.cities || []);
                setFacilities(data.facilities || []);

            } catch (err) {
                console.error("❌ Error fetching search summary:", err);
                setStates([]);
                setCounties([]);
                setCities([]);
                setFacilities([]);
            } finally {
                setLoading(false);
            }
        };

        fetchSearchSummary();
    }, [selectedOpenSearchValue, apiUrlconops, selectedState, selectedCounty, selectedCity, selectedFacility, selectedFacilityType]);



    // State Subscription
    useEffect(() => {
        if (!stateFocused) return;
        if (selectedOpenSearchValue) return
        const sub = searchStateSubject.current.pipe(
            debounceTime(debounceDuration),
            distinctUntilChanged(),
            switchMap(searchText =>
                from((async () => {
                    try {
                        const params = {
                            offset: 0,
                            limit: 100,
                            ...(searchText && { fac_state: searchText }),
                            ...(selectedCounty && { fac_county: selectedCounty }),
                            ...(selectedCity && { fac_city: selectedCity }),
                            ...(selectedFacility && { registry_id: selectedFacility }),
                            ...(selectedFacilityType && { fac_type: selectedFacilityType }),

                        };
                        setLoading(true);
                        const response = await apiClientconops.get(`${apiUrlconops}/state-list`, {
                            params,
                            paramsSerializer: params => qs.stringify(params, { arrayFormat: 'repeat' })
                        });
                        return response;
                    } catch {
                        return { data: { state_list_data: [] } };
                    } finally {
                        setLoading(false); // Stop loader
                    }
                })())
            )
        ).subscribe({
            next: (res) => {
                const data = res.data?.state_list_data || [];
                setStates(data);
            }
        });

        return () => sub.unsubscribe();
    }, [apiUrlconops, stateFocused, selectedOpenSearchValue, selectedCounty, selectedCity, selectedFacility, selectedFacilityType]);


    // County Subscription
    useEffect(() => {
        if (!countyFocused) return;
        if (selectedOpenSearchValue) return

        const sub = searchCountySubject.current.pipe(
            debounceTime(debounceDuration),
            distinctUntilChanged(),
            switchMap(searchText =>
                from((async () => {
                    try {
                        const params = {
                            offset: 0,
                            limit: 100,
                            ...(searchText && { fac_county: searchText }),

                            ...(selectedState && { fac_state: selectedState }),
                            ...(selectedCity && { fac_city: selectedCity }),
                            ...(selectedFacility && { registry_id: selectedFacility }),
                            ...(selectedFacilityType && { fac_type: selectedFacilityType }),

                        };
                        setLoading(true);
                        const response = await apiClientconops.get(`${apiUrlconops}/counties-list`, {
                            params,
                            paramsSerializer: params => qs.stringify(params, { arrayFormat: 'repeat' })
                        });
                        return response;
                    } catch {
                        return { data: { counties_list_data: [] } };
                    } finally {
                        setLoading(false); // Stop loader
                    }
                })())
            )
        ).subscribe({
            next: (res) => {
                const data = res.data?.counties_list_data || [];
                setCounties(data);
                // if (selectedFacility && data.length === 1) {
                //     setSelectedCountyObj(JSON.stringify(data[0]))
                // }
            }
        });

        return () => sub.unsubscribe();
    }, [apiUrlconops, countyFocused, selectedOpenSearchValue, selectedCity, selectedState, selectedFacility, selectedFacilityType]);



    // City Subscription
    useEffect(() => {
        if (!cityFocused) return;
        if (selectedOpenSearchValue) return
        const sub = searchCitySubject.current.pipe(
            debounceTime(debounceDuration),
            distinctUntilChanged(),
            switchMap(searchText =>
                from((async () => {
                    try {
                        const params = {
                            offset: 0,
                            limit: 50,
                            ...(searchText && { fac_city: searchText }),

                            ...(selectedState && { fac_state: selectedState }),
                            ...(selectedCounty && { fac_county: selectedCounty }),
                            ...(selectedFacility && { registry_id: selectedFacility }),
                            ...(selectedFacilityType && { fac_type: selectedFacilityType }),

                        };
                        setLoading(true);
                        const response = await apiClientconops.get(`${apiUrlconops}/cities-list`, {
                            params,
                            paramsSerializer: params => qs.stringify(params, { arrayFormat: 'repeat' })
                        });
                        return response;
                    } catch {
                        return { data: { cities_list_data: [] } };
                    } finally {
                        setLoading(false); // Stop loader
                    }
                })())
            )
        ).subscribe({
            next: (res) => {
                const data = res.data?.cities_list_data || [];
                setCities(data);
                // if (selectedFacility && data.length === 1) {
                //     setSelectedCityObj(JSON.stringify(data[0]))
                // }

            }
        });

        return () => sub.unsubscribe();
    }, [apiUrlconops, cityFocused, selectedFacility, selectedOpenSearchValue, selectedState, selectedCounty, selectedFacilityType]);


    //facility load data

    useEffect(() => {
        if (!facilityFocused) return;
        if (selectedOpenSearchValue) return
        const sub = searchFacilitySubject.current.pipe(
            debounceTime(debounceDuration),
            distinctUntilChanged(),
            switchMap(searchText =>
                from((async () => {
                    try {
                        const params = {
                            offset: 0,
                            limit: 100,
                            ...(searchText ? { fac_name: searchText } : {}),
                            ...(selectedState && { fac_state: selectedState }),
                            ...(selectedCounty && { fac_county: selectedCounty }),
                            ...(selectedCity && { fac_city: selectedCity }),
                            ...(selectedFacilityType && { fac_type: selectedFacilityType }),

                        };
                        setLoading(true);
                        const response = await apiClientconops.get(`${apiUrlconops}/facilities_list`, {
                            params,
                            paramsSerializer: params => qs.stringify(params, { arrayFormat: 'repeat' })
                        });
                        return response;
                    } catch {
                        return { data: { facilities_list_data: [] } };
                    } finally {
                        setLoading(false); // Stop loader
                    }
                })())
            )
        ).subscribe({
            next: (res) => {
                const data = res.data?.facilities_list_data || [];
                setFacilities(data);
                // if (data.length === 1 && localFilterState?.registryId) {
                //     setFacilitiesLoaded(true);
                // }
            }
        });

        return () => sub.unsubscribe();
    }, [apiUrlconops, facilityFocused, selectedOpenSearchValue, selectedState, selectedCounty, selectedCity, selectedFacilityType]);

    useEffect(() => {
        if (selectedFacility) {
            handleFacilityChange(null)
        }
    }, [selectedFacilityType])

    // handle open search
    const [openSearchKeyHolder, setOpenSearchKeyholder] = useState(selectedOpenSearchValue);

    // handle open search — updates context only when Enter or icon clicked
    const handleOpenSearch = () => {
        if (openSearchKeyHolder.trim() !== "") {
            setSelectedOpenSearchValue(openSearchKeyHolder.trim());
            setRegisterId(null)
        }
    };
    // handle clearing the input
    const handleClearSearch = () => {

        setOpenSearchKeyholder("");
        setSelectedOpenSearchValue(""); // clear context too
        setRegisterId(null)
        setSelectedFacility(null)
    };


    //handle state change
    const handleStateChange = async (value) => {
        setSelectedState(value);
        setRegisterId(null)
    }

    //handle county change
    const handleCountyChange = (countyValue) => {
        const countyObj = JSON.parse(countyValue || "{}");
        //console.log(countyValue, "countyvaluea")

        // Extract county and state
        const countyName = countyObj?.county || null;
        const stateName = countyObj?.state || null;

        // Update your states
        setSelectedCounty(countyName);
        setRegisterId(null)
        setCountyObject(null)
        if (countyValue) {
            setSelectedState(countyObj?.state || null);
            setCountyObject({ county: countyName, state: stateName })
        }

    };

    //handle city change
    const handleCityChange = (cityValue) => {
        const cityObj = JSON.parse(cityValue || "{}"); // default to empty object

        const cityName = cityObj?.city || null;
        const stateCode = cityObj?.state_code || null;
        const countyName = cityObj?.county || null;

        setSelectedCity(cityName);
        setRegisterId(null)
        if (cityValue) {
            setSelectedCounty(cityObj?.county || null);
            setSelectedState(cityObj?.state_code || null);
        }


    };


    //handle facility change
    const handleFacilityChange = async (value) => {
        //console.log(value, "facilitiesvalues")
        // setSelectedFacility(value);
        // setRegisterId(value)
        //new code after facility list added county
        if (!value) {
            setSelectedFacilityValue(null);
            setSelectedFacility(null);
            setRegisterId(null);
            setCountyObject(null);
            return;
        }
        setSelectedFacilityValue(value);
        const facilitiesObj = JSON.parse(value || "{}");
        const registerId = facilitiesObj?.registry_id || null;
        //extract county and state
        const county = facilitiesObj?.county || null;
        const stateCode = facilitiesObj?.state_code;
        setSelectedFacility(registerId)
        setRegisterId(registerId)
        setCountyObject(null)
        setFacilityTableObject([])
        if (value) {
            setCountyObject({ county: county, state: stateCode })
        }


    }

    const handleConopsHome = () => {
        //navigate("/conops-home");
        window.location.href = "/conops-home";
    }

    const handleReload = () => {
        window.location.reload()
    }

    return (
        <>
            <div className="conops-filtercontainer">

                <div className="row">
                    <div className="col-12">
                        <div className="row">
                            <div className="col-12">
                                <i onClick={handleConopsHome}
                                    className="bi bi-house-fill"
                                    style={{ fontSize: "1.5rem", cursor: "pointer", color: "#000000", paddingRight: "3px", position: "relative", top: "4px" }}
                                ></i>
                                <i onClick={handleReload}
                                    className="bi bi-arrow-clockwise"
                                    style={{ fontSize: "1.5rem", cursor: "pointer", color: "#000000", paddingRight: "4px", position: "relative", top: "4px" }}
                                ></i>
                                {/* Open Search Dropdown */}
                                {!refineSearchProjectObject && (
                                    <Input
                                        placeholder="Search"
                                        value={openSearchKeyHolder}
                                        onChange={(e) => setOpenSearchKeyholder(e.target.value)} // local only
                                        onPressEnter={handleOpenSearch} // commit on Enter
                                        allowClear
                                        onClear={handleClearSearch}
                                        suffix={
                                            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                                <SearchOutlined
                                                    onClick={handleOpenSearch}
                                                    style={{
                                                        cursor: "pointer",
                                                        color: openSearchKeyHolder ? "red" : "black",
                                                        fontSize: "18px",
                                                    }}
                                                />

                                            </div>
                                        }
                                        style={{ borderRadius: "20px", width: "83%" }}
                                    />
                                )}

                                {/* Refine Search Modal */}
                                <Button
                                    type="primary"
                                    style={{ borderRadius: "20px", marginLeft: "10px" }}
                                    onClick={() => setRefineSearchModalOpen(true)}
                                >
                                    Refine Search
                                </Button>

                                <ConopsRefineSearch
                                    open={refineSearchModalOpen}
                                    onClose={() => setRefineSearchModalOpen(false)}
                                />
                            </div>
                        </div>
                        <div className="row mt-4">
                            <div className="col-12">
                                {/* State Dropdown */}

                                <Select
                                    // className="filter-select"
                                    className={`filter-select ${refineSearchProjectObject ? "hidden" : ""}`}
                                    showSearch
                                    placeholder="Select State"
                                    value={selectedState}
                                    onChange={handleStateChange}
                                    allowClear
                                    style={{ width: "25%" }}
                                    onSearch={(value) => searchStateSubject.current.next(value)}
                                    onClear={() => searchStateSubject.current.next("")}
                                    onFocus={() => setStateFocused(true)}
                                    onBlur={() => setStateFocused(false)}
                                    optionFilterProp="children" // Ensures search filters by STATE_NAME dont delete
                                    notFoundContent={loading ? <Spin size="small" /> : null}
                                >
                                    {states.map((state, idx) => (
                                        <Option key={idx} value={state.state}>
                                            {state.state_name} ({state.state})
                                        </Option>
                                    ))}
                                </Select>
                                {/* County Dropdown */}

                                <Select
                                    // className="filter-select"
                                    className={`filter-select ${refineSearchProjectObject ? "hidden" : ""}`}
                                    showSearch
                                    placeholder="Select County"
                                    value={selectedCounty} // just the county name
                                    onChange={handleCountyChange}
                                    allowClear
                                    style={{ width: "25%" }}


                                    onSearch={(value) => searchCountySubject.current.next(value)}
                                    onClear={() => searchCountySubject.current.next("")}
                                    onFocus={() => setCountyFocused(true)}
                                    onBlur={() => setCountyFocused(false)}
                                    notFoundContent={loading ? <Spin size="small" /> : null}
                                >

                                    {counties.map((county, index) => (
                                        <Option
                                            key={`${index}_${county.county}`}
                                            value={JSON.stringify(county)}
                                        >
                                            {county.county},{county.state}
                                        </Option>
                                    ))}
                                </Select>
                                {/* city Dropdown */}

                                <Select
                                    // className="filter-select"
                                    className={`filter-select ${refineSearchProjectObject ? "hidden" : ""}`}
                                    showSearch
                                    placeholder="Select City"
                                    value={selectedCity}
                                    onChange={handleCityChange}
                                    allowClear
                                    style={{ width: "25%" }}

                                    onSearch={(value) => searchCitySubject.current.next(value)}
                                    onClear={() => searchCitySubject.current.next("")}
                                    onFocus={() => setCityFocused(true)}
                                    onBlur={() => setCityFocused(false)}
                                    notFoundContent={loading ? <Spin size="small" /> : null}
                                >
                                    {cities.map((city, idx) => (
                                        <Option key={idx} value={JSON.stringify(city)}>
                                            {city.city} ({city.state_code}) ({city.county})
                                        </Option>
                                    ))}
                                </Select>


                                {/* Facility Dropdown */}

                                <Select
                                    // className={"filter-select"}
                                    className={`filter-select ${refineSearchProjectObject ? "hidden" : ""}`}
                                    showSearch
                                    placeholder="Select Facility"
                                    value={selectedFacilityValue || undefined}
                                    onChange={handleFacilityChange}
                                    onSearch={(value) => searchFacilitySubject.current.next(value)}
                                    onClear={() => searchFacilitySubject.current.next("")}
                                    onFocus={() => setFacilityFocused(true)}
                                    onBlur={() => setFacilityFocused(false)}
                                    allowClear
                                    style={{ width: "25%" }}
                                    notFoundContent={loading ? <Spin size="small" /> : null}
                                    filterOption={(input, option) =>
                                        option?.children
                                            ?.toString()
                                            ?.toLowerCase()
                                            ?.includes(input.toLowerCase())
                                    }

                                >
                                    {facilities.map((facility, idx) => (
                                        <Option key={idx} value={JSON.stringify(facility)}>
                                            {facility.facility_name} - {facility.state_code}
                                        </Option>
                                    ))}
                                </Select>


                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </>
    )

}

export default ConopsFilterBar